export const FLAG = {
  OFF: 0,
  ON: 1,
  FAILED: 9,
}

export const ADDRESS_PER_PAGE = 20;
export const LETTER_ORDER_PER_PAGE = 20;
export const ORDER_PER_PAGE = 20;
export const DOWNLOAD_HISTORY_PER_PAGE = 20; // ダウンロード履歴（サマリー一覧）1ページあたりの件数
// 明細取得時の1ページ件数。明細APIの絞り込みは「日」単位のため、同一日の全レコードを取得して
// 対象注文（instructed_at完全一致）をフロントで抽出する。1日のダウンロード件数の想定上限として十分大きい値を指定する。
export const DOWNLOAD_HISTORY_DETAIL_PER_PAGE = 1000;
export const TIMELINE_STATUS_PER_PAGE = 20;
export const NOTIFICATIONS_PER_PAGE = 5;
export const DEPARTMENT_PER_PAGE = 11;
export const ACTIVITIES_PER_PAGE = 5;
export const DASHBOARD_PER_PAGE = 10;
export const ORDER_ADDRESSES_PER_PAGE = 11;
export const ADD_ORDER_CONTACT = -2;
export const SALESFORCE_PREVIEW_LIMIT = 3;
export const SALESFORCE_SYNC_HISTORIES_PER_PAGE = 5;
export const ADDRESS_NAME_PREVIEW_LIMIT = 5;
export const SALES_DEMO_ACCOUNT_ID = 109;
export const KEYMAN_CALL_CALLTREE_ACCOUNT_ID = 7400;
export const KEYMAN_LIST_DISPLAY_LIMIT = 5000; // キーマンデータベース表示件数上限
export const KEYMAN_COPY_DAILY_LIMIT = 20; // キーマンデータベースの1日あたりのコピー許容回数（超過でアラート表示・ログ記録）
export const KEYMAN_COPY_LOG_INTERVAL_AFTER_LIMIT = 50; // 上限超過後にコピペログを記録する間隔（この回数の倍数ごとに記録）
export const RELOCATION_LAST_3_YEARS = 3; // 直近３年以上の異動日
export const MAX_TRACKING_URL_LENGTH = 1024; // QRコードのURLの最大文字数
export const MAX_RECOMMEND_RANKING = 5; // レコメンドの最大ランク値

export const SECURITY_QUESTIONS = [
  "出身地は？",
  "ペットの名前は？",
  "子供の頃のニックネームは？",
  "子供の頃の親友の名前は？",
  "初めて仕事をした街は？",
  "恋人と出会った街は？",
  "お母さんの旧姓は",
];

export const SHEET_JSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");

// GW、お盆、年末年始の祝日は手動で追加してください。
// また追加する場合https://holidays-jp.github.io/api/v1/date.jsonから取得した最新の祝日データをコピペしてください。
export const HOLIDAYS_JP = {
  "2024-01-01": "元日",
  "2024-01-08": "成人の日",
  "2024-02-11": "建国記念の日",
  "2024-02-12": "建国記念の日 振替休日",
  "2024-02-23": "天皇誕生日",
  "2024-03-20": "春分の日",
  "2024-04-29": "昭和の日",
  "2024-05-03": "憲法記念日",
  "2024-05-04": "みどりの日",
  "2024-05-05": "こどもの日",
  "2024-05-06": "こどもの日 振替休日",
  "2024-07-15": "海の日",
  "2024-08-11": "山の日",
  "2024-08-12": "休日 山の日",
  "2024-09-16": "敬老の日",
  "2024-09-22": "秋分の日",
  "2024-09-23": "秋分の日 振替休日",
  "2024-10-14": "スポーツの日",
  "2024-11-03": "文化の日",
  "2024-11-04": "文化の日 振替休日",
  "2024-11-23": "勤労感謝の日",
  "2025-01-01": "元日",
  "2025-01-13": "成人の日",
  "2025-02-11": "建国記念の日",
  "2025-02-23": "天皇誕生日",
  "2025-02-24": "天皇誕生日 振替休日",
  "2025-03-20": "春分の日",
  "2025-04-29": "昭和の日",
  "2025-05-03": "憲法記念日",
  "2025-05-04": "みどりの日",
  "2025-05-05": "こどもの日",
  "2025-05-06": "みどりの日 振替休日",
  "2025-07-21": "海の日",
  "2025-08-11": "山の日",
  "2025-08-13": "お盆休み", // 手動追加
  "2025-08-14": "お盆休み", // 手動追加
  "2025-08-15": "お盆休み", // 手動追加
  "2025-09-15": "敬老の日",
  "2025-09-23": "秋分の日",
  "2025-10-13": "スポーツの日",
  "2025-11-03": "文化の日",
  "2025-11-23": "勤労感謝の日",
  "2025-11-24": "勤労感謝の日 振替休日",
  "2025-12-29": "正月休み",
  "2025-12-30": "正月休み",
  "2025-12-31": "正月休み",
  "2026-01-01": "元日",
  "2026-01-02": "正月休み",
  "2026-01-12": "成人の日",
  "2026-02-11": "建国記念の日",
  "2026-02-23": "天皇誕生日",
  "2026-03-20": "春分の日",
  "2026-04-29": "昭和の日",
  "2026-05-03": "憲法記念日",
  "2026-05-04": "みどりの日",
  "2026-05-05": "こどもの日",
  "2026-05-06": "憲法記念日 振替休日",
  "2026-07-20": "海の日",
  "2026-08-11": "山の日",
  "2026-08-13": "お盆休み", // 手動追加
  "2026-08-14": "お盆休み", // 手動追加
  "2026-09-21": "敬老の日",
  "2026-09-22": "国民の休日",
  "2026-09-23": "秋分の日",
  "2026-10-12": "スポーツの日",
  "2026-11-03": "文化の日",
  "2026-11-23": "勤労感謝の日"
};



// WEBPACK FOOTER //
// ./src/constants/Constants.js